import { create } from "zustand";
import moment from "moment";

interface DateRange {
  from: Date | undefined;
  to?: Date | undefined;
}

type SelectRangeEventHandler = (range: DateRange | undefined) => void;

interface DateRangeState {
  dateRange: DateRange;
  setDateRange: SelectRangeEventHandler;
}

function getMonthDates(month: number, year: number) {
  // Moment.js starts months from 0, so we subtract 1 from the input month
  const startDate = moment([year, month]).startOf("month").toDate();
  const endDate = moment([year, month]).endOf("month").toDate();

  return {
    startDate,
    endDate,
  };
}

export const useDateRangeStore = create<DateRangeState>()((set) => ({
  dateRange: {
    from: getMonthDates(new Date().getMonth(), new Date().getFullYear())
      ?.startDate,
    to: getMonthDates(new Date().getMonth(), new Date().getFullYear())?.endDate,
  },
  setDateRange: (range) => {
    // Your logic for updating the date range here
    // For simplicity, we'll just directly set the range
    set({ dateRange: range });
  },
}));
